import styles from './StatsCards.module.css';
import { UserRole } from '../../../enums/userRole';
import { hasMinRole } from '../../../lib/permissions';
import { McpTool } from '../../../types/types';
import { User } from '../../../types/user';
import { useConnectionsStore } from '../../../store/connectionsStore';

export default function StatsCards({ tools, users, user }: { tools: McpTool[]; users: User[]; user: User | null }) {
  const { connectors } = useConnectionsStore(state => state);
  const enabledTools = Array.isArray(tools) ? tools.filter(tool => tool.enabled) : [];

  return (
    <div className={styles.statsGrid}>
      <div className={styles.statCard}>
        <h3>Total Tools</h3>
        <div className={styles.statValue}>{tools ? tools.length : 0}</div>
      </div>
      <div className={styles.statCard}>
        <h3>Enabled Tools</h3>
        <div className={styles.statValue}>{enabledTools ? enabledTools.length : 0}</div>
      </div>
      {hasMinRole(user?.role?.id, UserRole.Admin) ? (
        <div className={styles.statCard}>
          <h3>Connected Users</h3>
          <div className={styles.statValue}>{users.filter(u => u.is_active).length}</div>
        </div>
      ) : <div className={styles.statCard}>
        <h3>Connectors</h3>
        <div className={styles.statValue}>{connectors.length || 0}</div>
      </div>}
    </div>
  );
}
